import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import MediaManager from '@/api/MediaManager';

class VisualComponent extends BasicComponent {
    getType() { return "VisualComponent"; }

    constructor( { id } = {} ) {
        super( { id });

        this.material = null;
        this.texture = null;
        this.mesh = null;
        this.scene = null;
        this.scaleFactor = 1;
    }

    setScaleFactor( value ){
        this.scaleFactor = value;
    }

    construct( context, prefab ) {
        const base = super.construct( context, prefab ).getRootNode();

        this.scene = context.scene;
        //console.log('Creating VisualComponent');
       
        if( !prefab.getIconID() ){
            return undefined;
        }
        
        //console.log("Getting Image for " + prefab.getImageID() );
   
        this.texture = MediaManager.getMedia(prefab.getIconID());
        const name = "VisualComponentImage_"+prefab.getIconID();

        //var panelTransition = new BABYLON_GUI.StackPanel();      
        this.material = new BABYLON.StandardMaterial(name + "_material", this.scene);
        this.mesh = undefined;
     
        if( this.texture.getTexture() ) {
            //console.log("Using existing texture with " + this.texture.getWidth() + " x " + this.texture.getHeight() + " and scale " +  prefab.getScale());

            this.mesh = BABYLON.MeshBuilder.CreatePlane(
                name, 
                { 
                    width: this.texture.getWidth() * prefab.getScale() * this.scaleFactor, 
                    height: this.texture.getHeight() * prefab.getScale() *this.scaleFactor,
                    sideOrientation: BABYLON.Mesh.DOUBLESIDE 
                }, context.scene);
         
            this.material.emissiveTexture = this.texture.getTexture();
            this.material.emissiveTexture.uScale = -1;
            this.material.emissiveTexture.vScale = -1;
            
        
            this.material.disableLighting = true;   
            this.material.opacityTexture = this.texture.getTexture();
            this.material.opacityTexture.uScale = -1;
            this.material.opacityTexture.vScale = -1;
           
        } else { 
            //console.log("Else Zweig " + prefab.getScale());
            this.mesh = BABYLON.MeshBuilder.CreatePlane(name, 10 * prefab.getScale(), this.scene);
            //console.log("image plane done, url:");
            //console.log("URL: " + texture.getURL());
            
            this.material.emissiveTexture = new BABYLON.Texture(this.texture.getURL(), this.scene);
            this.material.emissiveTexture.uScale = -1;
            this.material.emissiveTexture.vScale = -1;
        }

        this.material.emissiveTexture.hasAlpha = true;
        this.mesh.material = this.material;
        base.position = prefab.getPosition();

        if( prefab.getBillboard() ) {
            let cameraX =  this.scene.getCameraByName("MainCamera");
            let posCamera = cameraX.position;
             base.lookAt(posCamera);
            /*
            // With the following setting, the image will orient itself towards the camera...
            base.rotation = BABYLON.Vector3.Zero(); //rotation;
            base.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;

            */
        } else
            base.rotation = prefab.getRotation(); //// ACHTUNG vorher image
        
        this.mesh.parent = base;
        return base;
    }
}

export default VisualComponent;

